import { render, staticRenderFns } from "./ConsentSurveyModal.vue?vue&type=template&id=0daa87aa&scoped=true&"
import script from "./ConsentSurveyModal.vue?vue&type=script&lang=js&"
export * from "./ConsentSurveyModal.vue?vue&type=script&lang=js&"
import style0 from "./ConsentSurveyModal.vue?vue&type=style&index=0&id=0daa87aa&lang=scss&scoped=true&"
import style1 from "./ConsentSurveyModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa87aa",
  null
  
)

export default component.exports